import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === "/" && location.pathname === "/") return true;
    if (path !== "/" && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-sm border-b border-neutral-200"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-play-circle-fill text-2xl" style={{ color: "oklch(var(--primary-500))" }}></i>
            </div>
            <span className="text-xl font-bold" style={{ color: "oklch(var(--foreground-900))", fontFamily: "var(--font-heading)" }}>
              白云视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                isActive("/")
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-600 hover:text-foreground-900 hover:bg-background-100"
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                  isActive(`/category/${cat.slug}`)
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-600 hover:text-foreground-900 hover:bg-background-100"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                isActive("/about")
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-600 hover:text-foreground-900 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="text"
                placeholder="搜索影片..."
                className="pl-9 pr-4 py-2 rounded-full bg-background-100 text-sm text-foreground-800 placeholder:text-foreground-400 border border-transparent focus:border-primary-300 focus:bg-white transition-all outline-none w-48"
              />
            </div>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-neutral-100 bg-white pb-4">
            <div className="flex flex-col gap-1 px-2 pt-2">
              <Link to="/" className="px-4 py-3 rounded-lg text-sm font-medium hover:bg-background-100 transition-colors">首页</Link>
              {categories.map((cat) => (
                <Link key={cat.slug} to={`/category/${cat.slug}`} className="px-4 py-3 rounded-lg text-sm font-medium hover:bg-background-100 transition-colors">
                  {cat.name}
                </Link>
              ))}
              <Link to="/about" className="px-4 py-3 rounded-lg text-sm font-medium hover:bg-background-100 transition-colors">关于我们</Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}